import React ,{ useEffect }from "react";
import { useHistory , useParams  } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Form, Button, Card, Space } from "antd";
import FormFields from "./FormFields";
import { getSpecialtyById, updateSpecialty } from "../../../redux/slices/specialtys/specialtysThunk";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 12 },
};
const tailLayout = {
  wrapperCol: { offset: 12, span: 12, gutter: 10 },
};

const EditSpecialtiesPage = () => {
  const [form] = Form.useForm();
  const { id } = useParams();
  const dispatch = useDispatch();

  

  useEffect(() => {
    dispatch(getSpecialtyById(id));
  }, [dispatch, id]);

  const specialtyByIdData = useSelector((state) => state.specialtys.specialty);

  useEffect(() => {
      form.setFieldsValue({
        name: specialtyByIdData?.name,
        abreviation: specialtyByIdData?.abreviation,
      });
  }, [form, specialtyByIdData]);

  const onFinish = (values) => {
    const formattedValues = {
      name: values.name,
      abreviation: values.abreviation,
    };
    dispatch(updateSpecialty(
      {
        specialtyID: id,
        specialtyData: formattedValues,
      }
    )).then ((result) => {
      if (updateSpecialty.fulfilled.match(result)) {
        history.push("/spécialités");
      }
    }
    );
  };

  const onReset = () => {
    form.resetFields();
  };

  const history = useHistory();

  const navigateTo = (path) => {
    history.push(path);
  };


  return (
    <div>
      <Card
        bordered
        className="criclebox tablespace mb-24"
        title="Modifier une spécialité"
      />
      <Card bordered={false}>
        <Form
          {...layout}
          form={form}
          name="control-hooks"
          onFinish={onFinish}
        >
          <FormFields />
          <Form.Item {...tailLayout}>
            <Space size="small">
              <Button type="primary" htmlType="submit">
                Enregistrer
              </Button>
              <Button htmlType="button" onClick={onReset}>
                Reset
              </Button>
              <Button type="link" htmlType="button" onClick={() => navigateTo("/médecins")}>
                Annuler
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};


export default EditSpecialtiesPage;
